export enum SavedInfoSource {
  CHECKOUT = "checkout",
  ACCOUNT = "account",
}
